'use client'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white dark:bg-slate-800 rounded-lg shadow-lg dark:shadow-slate-900/50 p-6 border border-gray-200 dark:border-slate-700">
        <h2 className="text-2xl font-bold text-red-600 dark:text-red-400 mb-4">Bir Hata Oluştu</h2>
        <p className="text-gray-700 dark:text-gray-300 mb-4">
          {error.message || 'Beklenmeyen bir hata oluştu.'}
        </p>
        <button
          onClick={reset}
          className="w-full bg-red-600 dark:bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-700 dark:hover:bg-red-600 transition-colors"
        >
          Tekrar Dene
        </button>
        <details className="mt-4">
          <summary className="cursor-pointer text-sm text-gray-600 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400 transition-colors">Hata Detayları</summary>
          <pre className="mt-2 text-xs bg-gray-100 dark:bg-slate-700 text-gray-900 dark:text-gray-100 p-2 rounded overflow-auto max-h-40 border border-gray-200 dark:border-slate-600">
            {error.stack}
          </pre>
        </details>
      </div>
    </div>
  )
}

